import { Table, Row, Col, Button } from 'antd';
import { FC } from 'react';
import { useBookings } from './useBookings';
import { useHistory } from 'react-router-dom';
import { useCenters } from '../centers/useCenters';
import { useColaborators } from '../colaborators/useColaborators';
import { useCustomers } from '../final-customers/useCustomers';
import { useServices } from '../services/useServices';
import { Booking } from 'src/api/bookings';
import { FormattedDate } from 'react-intl';

const { Column } = Table;

interface Props {}
export const BookingsTable: FC<Props> = () => {
  const { centersQuery } = useCenters();
  const { customersQuery } = useCustomers();
  const { colaboratorsQuery } = useColaborators();
  const { servicesQuery } = useServices();

  const { bookingsQuery } = useBookings();
  const history = useHistory();
  function openBooking(bookingID: string) {
    history.push(`/apps/cockpit/bookings/${bookingID}`);
  }
  const dereferenceBookingAttributes = (row: Booking) => {
    return {
      ...row,

      customer: customersQuery.data?.find((c) => c.id === row.customerID)?.name,
      colaborator: colaboratorsQuery.data?.find(
        (c) => c.id === row.colaboratorID,
      )?.name,
      center: centersQuery.data?.centers.find((c) => c.id === row.centerID)
        ?.name,
      service: servicesQuery.data?.find((c) => c.id === row.serviceID)?.name,
      date: (
        <FormattedDate
          year='numeric'
          month='2-digit'
          day='2-digit'
          hour='2-digit'
          minute='2-digit'
          value={row.date}
        />
      ),
    };
  };
  const data =
    bookingsQuery.data?.map(dereferenceBookingAttributes).map((booking) => ({
      key: booking.id,
      ...booking,
      actions: (
        <Row>
          <Col md={6} span={12} className='hp-pr-sm-0 hp-pr-12'>
            <Button
              onClick={() => openBooking(booking.id)}
              block
              type='primary'
              htmlType='submit'
            >
              Abrir
            </Button>
          </Col>
        </Row>
      ),
    })) || [];

  return (
    <>
      <Row gutter={[32, 32]} className='hp-ecommerce-app hp-mb-32'>
        <Col span={24}>
          {bookingsQuery.isLoading && (
            <Table loading>
              <Column title='Nome' dataIndex='name' key='name' />
              <Column title='Ações' dataIndex='actions' key='actions' />
            </Table>
          )}
          {bookingsQuery.data && (
            <Table dataSource={data}>
              <Column
                title='Colaborador'
                dataIndex='colaborator'
                key='colaborator'
              />
              <Column title='Cliente' dataIndex='customer' key='customer' />
              <Column title='Centro' dataIndex='center' key='center' />
              <Column title='Serviço' dataIndex='service' key='service' />
              <Column
                title='Duração (em minutos)'
                dataIndex='serviceDurationInMinutes'
                key='serviceDurationInMinutes'
              />
              <Column title='Data' dataIndex='date' key='date' />
              <Column title='Ações' dataIndex='actions' key='actions' />
            </Table>
          )}
        </Col>
      </Row>
    </>
  );
};

export default BookingsTable;
